export default __webpack_public_path__ + "static/media/image-two.5b8b687c.jpg";